import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — scrolls window to top on every route change.
 * Skips scroll if the incoming URL has a hash target (anchor link),
 * so in-page anchors keep working.
 */
export default function ScrollToTop() {
    const { pathname, hash, search } = useLocation();
    useEffect(() => {
        if (hash) return; // let browser handle in-page anchor
        // Prefer instant to avoid jarring smooth-scroll on navigation
        try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
        catch { window.scrollTo(0, 0); }
    }, [pathname, hash, search]);
    return null;
}
